module.exports = __webpack_public_path__ + "img/pilot_training_detail.7f68bd00.png";